import React, { Fragment } from "react";
import { Link as RouterLink } from "react-router-dom";

import Box from "@material-ui/core/Box";
import Link from "@material-ui/core/Link";
import Paper from "@material-ui/core/Paper";
import { makeStyles } from "@material-ui/core/styles";

import {
  MEDIA_THUMBNAIL_URL,
  PLACEHOLDER_IMG_360x360_URL,
  PLACEHOLDER_IMG_360x360_ERROR_URL,
  IMG_BG_COLOR,
} from "../../config";
import StatusChip from "./StatusChip";
import KeyValue from "../display/KeyValue";
import { fromUnixtime, /*fromIsoOnlyDate*/ } from "../../utils/time";
import ListItem from "../display/ListItem";
import { userUrl } from "../../utils/url";
import SocialLoginIcons from "./SocialLoginIcons";
import SpamCounts from "./SpamCounts";

const useStyles = makeStyles((theme) => ({
  paper: {
    padding: theme.spacing(2),
    margin: "auto",
    //backgroundColor: "#212121",
    marginTop: theme.spacing(1),
  },
  img: {
    width: 150,
    height: 150,
    margin: "auto",
    objectFit: "cover",
    backgroundColor: IMG_BG_COLOR,
  },
}));

export default function ResultGrid({ user }) {
  const classes = useStyles();

  return (
    <Paper className={classes.paper}>
      <ListItem
        header={
          <Link
            color="inherit"
            component={RouterLink}
            to={`/travalour/${user.id}`}
            underline="none"
            variant="subtitle2"
          >
            {`${user.name} (${user.id})`}
          </Link>
        }
        contentLeft={
          <Box
            display="flex"
            flexDirection="column"
            alignItems="center"
            height="100%"
            style={{ marginTop: 10 }}
          >
            <Box>
              <img
                className={classes.img}
                alt=""
                src={
                  !!user.image
                    ? `${MEDIA_THUMBNAIL_URL}/${user.image}?width=240`
                    : PLACEHOLDER_IMG_360x360_URL
                }
                onError={(e) => {
                  e.target.onerror = null;
                  e.target.src = PLACEHOLDER_IMG_360x360_ERROR_URL;
                }}
              />
            </Box>
            <Link
              href={userUrl(user.username, true)}
              underline="none"
              target="_blank"
              color="textSecondary"
            >
              {`@${user.username} `}
            </Link>
            <Box>
              <StatusChip status={user.status} />
            </Box>
          </Box>
        }
        contentRight={
          <Fragment>
            <KeyValue
              keyName="Social Logins"
              value={<SocialLoginIcons socialLogin={user.socialLogin} />}
            />
            <KeyValue keyName="Email" value={user.email} />
            {/* <KeyValue
              keyName="Date Of Birth"
              value={fromIsoOnlyDate(user.dob)}
            /> */}
            <KeyValue
              keyName="Created On"
              value={fromUnixtime(user.createdOn)}
            />
            <KeyValue
              keyName="Spam Reports"
              value={<SpamCounts spamCount={user.spamCount} />}
            />
          </Fragment>
        }
      />
    </Paper>
  );
}
